import { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import AjvErrors from 'ajv-errors';
import Ajv from 'ajv';
import reduce from 'lodash/reduce';
import { CardHeader, Divider, Grid, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { addTemplateUISchema, templateFormSchema, templateTagsSchema } from './form';
import FormModal from '../../common/formModal';
import MetaTagsTable from '../../common/metaTagsTable';
import Styles from '../../theme/commonCss/Styles';
import { get } from 'lodash';
import { palette } from '../../theme/palette';
import { secretManagerActions } from '../../store/reducers/secret-manager';
import SecretMetaTags from './common/SecretMetaTags';

const AddEditTemplate = ({
  isOpen,
  templateSelectedData,
  setTemplateSelectedData,
  templateTagsData,
  setTemplateTagsData,
  isEdit,
  closeModal = () => { },
  pageData,
  readonly,
  templateData,
  hasAccessTo
}: any) => {
  const themeData: any = useTheme();
  const dispatch = useDispatch();
  const responsiveSize = useMediaQuery('(max-width:900px)');
  const ajv = new Ajv({ allErrors: true });
  AjvErrors(ajv);
  const [ajvErrors, setAjvErrors] = useState<any>({});
  const [isValidName, setIsValidName] = useState<any>({});

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setTemplateSelectedData({ ...templateSelectedData, [name]: value });
    if (name === 'template_name' && !isEdit) {
      if (templateData.findIndex((item: any) => item.template_name.toLowerCase() === value.toLowerCase()) > -1) {
        var obj = {
          ['template_name']: true,
        };
        setIsValidName(obj);
      } else {
        setIsValidName({});
      }
    }
    // validateForm();
  };

  const validateForm = () => {
    let ajvSchema: any = JSON.parse(JSON.stringify({ ...templateFormSchema }));

    if (templateTagsData.length) {
      ajvSchema = {
        ...templateFormSchema,
        properties: {
          ...templateFormSchema.properties,
          template_tags: {
            type: 'array',
            items: templateTagsData.map((item: any) => templateTagsSchema),
          },
        },
        required: [...templateFormSchema.required, 'template_tags'],
      };
    }

    const validate = ajv.compile(ajvSchema);

    const trimmedtemplateSelectedData = reduce(
      templateSelectedData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );

    const trimmedtemplateTagsData = reduce(
      templateTagsData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );

    setTemplateSelectedData(trimmedtemplateSelectedData);

    const reqParams = {
      ...trimmedtemplateSelectedData,
      template_tags: templateTagsData,
    };

    if (validate({ ...reqParams })) {
      setAjvErrors({});
      return true;
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
      return false;
    }
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    let ajvSchema: any = JSON.parse(JSON.stringify({ ...templateFormSchema }));

    if (templateTagsData.length) {
      ajvSchema = {
        ...templateFormSchema,
        properties: {
          ...templateFormSchema.properties,
          template_keys: {
            type: 'array',
            items: templateTagsData.map((item: any) => templateTagsSchema),
          },
        },
        required: [...templateFormSchema.required, 'template_keys'],
      };
    }

    const validate = ajv.compile(ajvSchema);

    const trimmedtemplateSelectedData = reduce(
      templateSelectedData,
      (acc: any, value: any, key: any) => {
        acc[key] = typeof value === 'string' ? value.trim() : value;
        return {
          ...acc,
        };
      },
      {}
    );
    setTemplateSelectedData(trimmedtemplateSelectedData);

    const trimmedTemplateTag = templateTagsData.map((item: any) => {
      return {
        ...item,
        key: typeof item.key === 'string' ? item.key.trim() : item.key,
      };
    });

    setTemplateTagsData(trimmedTemplateTag);

    const reqParams = {
      ...trimmedtemplateSelectedData,
      template_keys: trimmedTemplateTag,
    };

    if (validate({ ...reqParams })) {
      const finalPaylod: any = {
        ...reqParams, template_keys: reqParams.template_keys.map((item: any) => item.key)
      }

      if (isEdit) {
        dispatch(secretManagerActions.updateSecretTemplateRequest(finalPaylod));
      } else {
        dispatch(secretManagerActions.addSecretTemplateRequest(finalPaylod));
      }
      closeModal();
      setAjvErrors({});
    } else {
      if (validate.errors) {
        setAjvErrors(validate.errors[0]);
      }
    }
  };

  return (
    <FormModal
      title={`${isEdit ? 'EDIT ' : readonly ? 'VIEW' : 'ADD NEW '} TEMPLATE`}
      isOpen={isOpen}
      handleSubmit={handleSubmit}
      handleClose={closeModal}
      readOnly={readonly}
      customStyles={{ width: '700px' }}
    >
      <Grid
        container
        spacing={1}
        textAlign={'right'}
        sx={{
          ...Styles.gridContainer,
          marginLeft: 0,
          alignItems: 'center',
          marginTop: responsiveSize ? '0px' : '12px',
        }}
      >
        {addTemplateUISchema.map(({ label, name, required }: any) => (
          <Fragment key={name}>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              sx={{
                ...Styles.gridItem,
                '&.MuiGrid-item': {
                  paddingTop: '0px !important',
                  pl: '0px !important',
                  justifyContent: responsiveSize ? 'flex-start' : 'flex-end',
                  alignItems: 'center',
                  height: '48px'
                },
              }}
            >
              <Typography
                sx={{ ...Styles.inputLabel, color: themeData.palette.text.primary }}
                className={required ? 'required-field' : ''}
              >
                {label}
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              sx={{
                '&.MuiGrid-item': {
                  padding: responsiveSize ? '4px 0 0' : '12px 0px',
                  pl: '0px',
                  height: '78px'
                },
              }}
            >
              <TextField
                sx={{
                  '&.MuiTextField-root': {
                    margin: '0px',
                    marginTop: '6px',
                  },
                }}
                margin='normal'
                fullWidth
                id={name}
                onChange={handleChange}
                inputProps={{ readOnly: readonly }}
                disabled={readonly}
                // onBlur={validateForm}
                name={name}
                autoComplete={name}
                autoFocus={name === 'template_name' ? true : false}
                variant='outlined'
                value={templateSelectedData[name]}
                size='small'
                helperText={
                  name === 'template_name' ? (
                    isValidName['template_name'] ? (
                      <p
                        style={{
                          color: palette.error.main,
                          fontSize: '0.75rem',
                          textAlign: 'left',
                          padding: '0',
                          margin: '0',
                          marginLeft: '5px',
                        }}
                      >
                        TEMPLATE NAME already exists!! Please specify alternative "TEMPLATE NAME".{' '}
                      </p>
                    ) : (
                      ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message
                    )
                  ) : (
                    ajvErrors.instancePath && ajvErrors.instancePath.includes(name) && ajvErrors.message
                  )
                }
                error={
                  name === 'template_name'
                    ? isValidName['template_name']
                      ? true
                      : ajvErrors.instancePath && ajvErrors.instancePath.includes(name)
                    : ajvErrors.instancePath && ajvErrors.instancePath.includes(name)
                }
              />
            </Grid>
          </Fragment>
        ))}
      </Grid>

      <CardHeader title='Secret Keys' titleTypographyProps={Styles.title} />
      <Divider />
      <SecretMetaTags
        data={templateTagsData.length ? templateTagsData : [{ id: 1, key: '' }]}
        setData={setTemplateTagsData}
        isFromTemplate={true}
        readOnly={readonly}
        overlayMsg={'Please add template key definition!'}
        error={ajvErrors.instancePath && ajvErrors.instancePath.includes('template_keys')}
        hasAccessTo={isEdit ? hasAccessTo : { ...hasAccessTo, delete: true }}
      />
    </FormModal>
  );
};

export default AddEditTemplate;
